import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/database'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'
import 'firebase/compat/analytics'
import 'firebase/compat/functions'

import config from './config'

// TODO: Start upgrading firebase from version 8 compat to 9 modular.
const isDev = process && process.env && process.env.NODE_ENV === 'development'

const app = firebase.initializeApp(config)

const auth = firebase.auth()
const db = app.database()
const fsdb = app.firestore()
const storage = firebase.storage()
const analytics = firebase.analytics(app)
const functions = firebase.functions(app)
analytics.setAnalyticsCollectionEnabled(!isDev)

if (isDev) {
  if (process.env.VUE_APP_USE_AUTH_EMULATOR === 'true') {
    auth.useEmulator('http://localhost:9099/')
  }
}

const url = config.databaseURL
const projectId = config.projectId

export default app
export {
  auth,
  analytics,
  db,
  firebase,
  functions,
  fsdb,
  storage,
  url,
  projectId
}
